const routeConstant = {
  auth: {
    path: "/",
    title: "Login",
  },
  dashboard: {
    path: "/",
    title: "Dashboard",
  },
  demoRequests: {
    path: "/demo-requests",
    title: "Demo Requests",
  },
  demoRequestDetail: {
    path: "/demo-requests/:id",
    title: "Demo Request Detail",
  },
  demoRequestCreatePlan: {
    path: "/demo-requests/:id/create-plan",
    title: "Create School Plan",
  },
  demoRequestSchoolDetail: {
    path: "/school-detail/:id",
    title: "School Detail",
  },
  appAnalytics: {
    path: "/app-analytics",
    title: "App Analytics",
  },
  appAnalyticsOverview: {
    path: "/app-analytics/overview",
    title: "Overview",
  },
  appAnalyticsInstalls: {
    path: "/app-analytics/installs",
    title: "Installs",
  },
  appAnalyticsUninstalls: {
    path: "/app-analytics/uninstalls",
    title: "Uninstalls",
  },
  appAnalyticsDevices: {
    path: "/app-analytics/devices",
    title: "Devices",
  },
  appAnalyticsActivity: {
    path: "/app-analytics/activity",
    title: "Activity",
  },
  appAnalyticsRetention: {
    path: "/app-analytics/retention",
    title: "Retention",
  },
  authorsListing: {
    path: "/authors-listing",
    title: "Authors Listing",
  },
  tickets: {
    path: "/tickets",
    title: "Tickets",
  },
  singleTicket: {
    path: "/ticket/:id",
    title: "Ticket",
  },
  publishers: {
    path: "/publishers",
    title: "Publishers",
  },
  chat: {
    path: "/chats",
    title: "Chats",
  },
  books: {
    path: "/books",
    title: "Books",
  },
  series: {
    path: "/series",
    title: "Series",
  },
  author: {
    path: "/authors",
    title: "Authors",
  },
  bookReviewer: {
    path: "/book-reviewers",
    title: "Book Reviewer",
  },
  settings: {
    path: "/settings",
    title: "Settings",
  },
  publisherProfile: {
    path: "/publisher/:id",
    title: "Publisher",
  },
  mou: {
    path: "/mou/:id",
    title: "Agreement",
  },
  bookDetail: {
    path: "/book/:id",
    title: "Book Detail",
  },
  seriesDetail: {
    path: "/series/:id",
    title: "Series Detail",
  },
  bookReview: {
    path: "/book-reviewer/:id",
    title: "Book Reviewer",
  },
  reviewByHOD: {
    path: "/review-by-hod/:id",
    title: "Book Review",
  },
  reviewSeriesByHOD: {
    path: "/review-series-by-hod/:id",
    title: "Series Review",
  },
  review: {
    path: "/review/:id",
    title: "Book Review",
  },
  reviewSeries: {
    path: "/review-series/:id",
    title: "Series Review",
  },
  profile: {
    path: "/profile/:id",
    title: "Profile",
  },
  transactions: {
    path: "/transactions",
    title: "Transactions",
  },
  membership: {
    path: "/membership",
    title: "Membership",
  },

  schoolAccounts: {
    path: "/school-accounts",
    title: "School Accounts",
  },
  schoolRequests: {
    path: "/school-requests",
    title: "School Requests",
  },
  schoolTickets: {
    path: "/school-tickets",
    title: "Tickets",
  },
  schoolDetail: {
    path: "/school/:id",
    title: "School Details",
  },
  softCopy: {
    path: "/soft-copy",
    title: "Soft Copy",
  },
  hardCopy: {
    path: "/hard-copy",
    title: "Hard Copy",
  },
  booksCatalog: {
    path: "/books-catalog",
    title: "Books catalog",
  },
  customerSupport: {
    path: "/customer-support",
    title: "Customer Support",
  },
  featuredBooks: {
    path: "/featured-books",
    title: "Featured Books",
  },
  requiredBooks: {
    path: "/reported-books",
    title: "Reported Books",
  },
  allMou: {
    path: "/all-mou",
    title: "All Agreement",
  },
  bestSellers: {
    path: "/best-sellers",
    title: "Best Sellers",
  },
  reviewersPerformance: {
    path: "/reviewer-performance",
    title: "Reviewer Performance",
  },
  partnerAccount: {
    path: "/partner-account",
    title: "Partner Account",
  },
  usersAccountsDetail: {
    path: "/accounts-details/:keyword",
    title: "Accounts Detail",
  },
  pendingTasks: {
    path: "/pending-tasks/:keyword/:task",
    title: "Pending Tasks",
  },
  partnersDetail: {
    path: "/partners-details/:keyword",
    title: "Partners Detail",
  },
  earningDetail: {
    path: "/earning-details",
    title: "Earning Details",
  },
  approveRequest: {
    path: "/approve-requests",
    title: "Approve Requests",
  },
  partnerProfile: {
    path: "/partner-profile/:role/:id",
    title: "Profile",
  },
  partners: {
    path: "/partners",
    title: "Partners",
  },
  projectHeadTransactions: {
    path: "/transaction",
    title: "Transaction",
  },
  books_summary: {
    path: "/books-summary",
    title: "Books",
  },
  schoolAnalytics: {
    path: "/school-analytics",
    title: "School Analytics",
  },
  schoolAnalyticsDetail: {
    path: "/school-analytics/:id",
    title: "School Detail",
  },
  controlCenter: {
    path: "/control-center",
    title: "Control Center",
  },
  partnerListings: {
    path: "/partnerListings",
    title: "Partners Listing",
  },
  bookSearch: {
    path: "/book-search/",
    title: "Book Search",
  },
  allplanstransactions: {
    path: "/allPlansTransactions",
    title: "All Plans Transactions",
  },
  manageBooks: {
    path: "/manage-books",
    title: "Manage Books",
  },
  allBooksListings: {
    path: "/books-listings",
    title: "All Books",
  },
  leadershipBoard: {
    path: "/leadership-board",
    title: "Leadership Board",
  },
  dashboardView: {
    path: "/dashboard-view/:role",
    title: "Dashboard View",
  },
  reviewerPerformance: {
    path: "/reviewer-performance/:id",
    title: "Reviewer Performance",
  },
  singleAuthor: {
    path: "/author/:id",
    title: "Author",
  },
  reportedUsers: {
    path: "/reported-users",
    title: "Reported Users",
  },
  bookPreview: {
    path: "/book-preview/:id/:slug",
    title: "Book",
  },
  reports: {
    path: "/reports/:id",
    title: "Reports",
  },
  mouHead: {
    path: "/mou-signature/:id",
    title: "Agreement",
  },
  reportBookDetails: {
    path: "/report-book-detail/:id",
    title: "Report Book Detail",
  },
  bookRevisions: {
    path: "/book-revisions/:id",
    title: "Book Revisions",
  },
  bookAudioRevisions: {
    path: "/book-audio-revisions/:id",
    title: "Book Audio Revisions",
  },
  seriesRevisions: {
    path: "/series-revisions/:id",
    title: "Series Revisions",
  },
  accounts: {
    path: "/accounts",
    title: "Accounts",
  },

  sales: {
    path: "/sales",
    title: "Sales",
  },
  aliflailaIndividualUsers: {
    path: "/individuals",
    title: "Individuals",
  },
  aliflailaSchoolUsers: {
    path: "/school-users",
    title: "School",
  },
  individualDetail: {
    path: "/individual/:id",
    title: "Individual Details",
  },
  parentUsers: {
    path: "/parents",
    title: "Parents",
  },
  parentDetail: {
    path: "/parent/:id",
    title: "Parent Details",
  },
  subscriptionRequest: {
    path: "/subscription-request",
    title: "Subscription Request",
  },
  subscriptions: {
    path: "/subscriptions",
    title: "Subscriptions",
  },
  customNotifications: {
    path: "/custom-notifications",
    title: "Notifications",
  },
  termsAndCondition: {
    path: "/terms-and-conditions",
    title: "Terms & Condition",
  },
  notificationListings: {
    path: "/notification-listings",
    title: "Notification Listings",
  },
  privacyPolicy: {
    path: "/privacy-policy",
    title: "Privacy Policy",
  },
  newsletterSubscription: {
    path: "/newsletter-subscriptions",
    title: "Newsletter Subscriptions",
  },
  transactionHistory: {
    path: "/transaction-history",
    title: "Transaction History",
  },
  banners: {
    path: "/banners",
    title: "App Banners",
  },
  notifications: {
    path: "/notifications",
    title: "Notifications",
  },
  bannerControl: {
    path: "/banner-control",
    title: "Banner Control",
  },
  manageBanner: {
    path: "/manage-banner",
    title: "Manage Banner",
  },
  promoCodes: {
    path: "/promo-codes",
    title: "Promo Codes",
  },
  qrCodeOverview: {
    path: "/qr-code-overview",
    title: "QR Code Overview",
  },
  qrCodeManagement: {
    path: "/qr-code-management",
    title: "QR Code Management",
  },
  subscription: {
    path: "/subscription",
    title: "Subscription",
  },
  purchasedPlansHistory: {
    path: "/purchasedplanhistory/:role",
    title: "Purchased Plan history",
  },
  phNewAllMouSignature: {
    path: "/all-mou-signature/:id",
    title: "MOU List",
  },
};
export { routeConstant };
